import React from 'react';

import styles from './Spinner.module.css';

interface ISpinnerProps {
  color: string,
  style?: any,
  size: number,
}

const originSize = 80;

const Spinner: React.FC<ISpinnerProps> = (props) => {
  const { color = '#fff', style = {}, size = originSize } = props;
  const backgroundColor = `${color}`;

  return (
    // eslint-disable-next-line no-mixed-operators
    <div className={styles.ldsSpinner} style={{ fontSize: size * 10 / originSize, ...style }}>
      {Array(12).fill('').map(() => <div style={{ backgroundColor }} />)}
    </div>
  );
};

export default Spinner;
